/* src/app/modules_v2/booking/availability/components/location-exceptions/location-exceptions.component.css */
.exceptions-container {
  padding: 20px;
}
h3 {
  color: var(--cf-chrome);
  margin-bottom: 16px;
}
/*# sourceMappingURL=location-exceptions.component.css.map */
